import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

class Page {
  constructor(path = null, component = null, name = null, meta = null, beforeEnter = null) {
    this.path = path
    this.name = name
    this.component = () => import(`@/pages/${component}`)
    this.beforeEnter = beforeEnter
    this.meta = meta
  }
}

export default new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { path: '/', redirect: '/schedule-list' },
    new Page('/schedule-list', 'ScheduleList', 'scheduleList'),
    new Page('/show-exel/:idExel', 'ShowExel', 'showExelById')
  ]
})
